import { signal } from "@preact/signals-react";
import { logClientNumber, logToken } from "./login.signal";

export const OrderData = signal(null);
export const OrderDetailsData = signal(null);
export const searchOrderData = signal(null);
export const searchProductData = signal(null);
export const cartProductData = signal(null);

export async function fetchOrderApi() {
  const url = "https://alguthmi.co/API/B2BAppAPI/fetchOrders.php";
  const bearerToken = logToken.value;

  const options = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      CLICODE: logClientNumber.value,
    }),
  };

  try {
    const response = await fetch(url, options);

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error:", error);
  }
}

export async function fetchOrderDetailsApi(
  P_TYPE,
  COMPANY_NUMBER,
  BAR_CODE,
  INVOICE_TYPE,
  INVOICE_NUMBER,
  INVOICE_DATE
) {
  const url = "https://alguthmi.co/API/B2BAppAPI/fetchOrderDetails.php";
  const bearerToken = logToken.value;
  const options = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      COMPANY_NUMBER: COMPANY_NUMBER,
      BAR_CODE: BAR_CODE,
      INVOICE_TYPE: INVOICE_TYPE,
      INVOICE_NUMBER: INVOICE_NUMBER,
      INVOICE_DATE: INVOICE_DATE,
      TYPE: P_TYPE,
    }),
  };

  try {
    const response = await fetch(url, options);

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error:", error);
  }
}
export async function fetchSearchOrderApi(INVOICE_NUMBER) {
  const url = "https://alguthmi.co/API/B2BAppAPI/fetchSearchOrders.php";
  const bearerToken = logToken.value;

  const options = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      INVOICE_NUMBER: INVOICE_NUMBER,
    }),
  };

  try {
    const response = await fetch(url, options);

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error:", error);
  }
}

export async function fetchSearchProductApi(
  P_CLICODE,
  P_OUTLET,
  P_ART_CODE,
  P_SEARCH_TYPE,
  P_CATALOG_NUM,
  P_TYPE,
  P_SERIAL,
  P_QUANTITY,
  P_STATE,
  P_SMALLEST_PIECE,
  P_WHS,
  P_LANG
) {
  const url = "https://alguthmi.co/API/B2BAppAPI/fetchSearchProduct.php";
  const bearerToken = logToken.value;

  const options = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      SKU: P_ART_CODE,
      SEARCH_TYPE: P_SEARCH_TYPE,
      CATALOG_NUM: P_CATALOG_NUM,
      TYPE: P_TYPE,
      SERIAL: P_SERIAL,
      QUANTITY: P_QUANTITY,
      STATE: P_STATE,
      SMALLEST_PIECE: P_SMALLEST_PIECE,
      ALLWHS: P_WHS,
      LANGUAGE: P_LANG,
    }),
  };

  try {
    const response = await fetch(url, options);

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error:", error);
  }
}
